export const APP_PLATFORM = {
  WEB: "web",
  MOBILE: "mobile",
};
